/* src/app/components/app-group-wrapper/group-wrapper.component.css */
/*# sourceMappingURL=group-wrapper.component-H4SQ26N5.css.map */
